import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useMemo } from "react";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import SplashScreen from "./components/SplashScreen";
import Home from "./pages/Home";
import ChiSiamo from "./pages/ChiSiamo";
import InfoAgibilita from "./pages/InfoAgibilita";
import F24Page from "./pages/F24Page";
import DichiarazioneMensile from "./pages/DichiarazioneMensile";
import ContattiPage from "./pages/ContattiPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import RecuperaPasswordPage from "./pages/RecuperaPasswordPage";
import ReimpostaPasswordPage from "./pages/ReimpostaPasswordPage";
import NewsPage from "./pages/NewsPage";
import CalcolatorePage from "./pages/CalcolatorePage";
import DashboardPage from "./pages/DashboardPage";
import RichiestaAgibilitaPage from "./pages/RichiestaAgibilitaPage";
import MieRichiestePage from "./pages/MieRichiestePage";
import DettaglioRichiestaPage from "./pages/DettaglioRichiestaPage";
import ProfiloPage from "./pages/ProfiloPage";
import AssistenzaPage from "./pages/AssistenzaPage";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminRichieste from "./pages/admin/AdminRichieste";
import AdminIscritti from "./pages/admin/AdminIscritti";
import AdminIscrittoDettaglio from "./pages/admin/AdminIscrittoDettaglio";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  const fromState = useMemo(() => ({ from: location }), [location]);
  if (user === undefined) return <div className="px-4 py-24 text-center text-sm text-muted-foreground">Caricamento...</div>;
  if (!user) return <Navigate to="/accedi" state={fromState} replace />;
  return children;
}

function AdminRoute({ children }) {
  const { user, isAdmin } = useAuth();
  if (user === undefined) return <div className="px-4 py-24 text-center text-sm text-muted-foreground">Caricamento...</div>;
  if (!user) return <Navigate to="/accedi" replace />;
  if (!isAdmin) return <Navigate to="/area-personale" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SplashScreen />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/chi-siamo" element={<ChiSiamo />} />
              <Route path="/certificato-agibilita" element={<InfoAgibilita />} />
              <Route path="/f24" element={<F24Page />} />
              <Route path="/dichiarazione-mensile" element={<DichiarazioneMensile />} />
              <Route path="/contatti" element={<ContattiPage />} />
              <Route path="/accedi" element={<LoginPage />} />
              <Route path="/iscriviti" element={<RegisterPage />} />
              <Route path="/recupera-password" element={<RecuperaPasswordPage />} />
              <Route path="/reimposta-password" element={<ReimpostaPasswordPage />} />
              <Route path="/news" element={<NewsPage />} />
              <Route path="/calcolatore" element={<CalcolatorePage />} />
              <Route path="/area-personale" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
              <Route path="/richiedi-agibilita" element={<ProtectedRoute><RichiestaAgibilitaPage /></ProtectedRoute>} />
              <Route path="/le-mie-richieste" element={<ProtectedRoute><MieRichiestePage /></ProtectedRoute>} />
              <Route path="/le-mie-richieste/:id" element={<ProtectedRoute><DettaglioRichiestaPage /></ProtectedRoute>} />
              <Route path="/profilo" element={<ProtectedRoute><ProfiloPage /></ProtectedRoute>} />
              <Route path="/assistenza" element={<ProtectedRoute><AssistenzaPage /></ProtectedRoute>} />
              <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
              <Route path="/admin/richieste" element={<AdminRoute><AdminRichieste /></AdminRoute>} />
              <Route path="/admin/iscritti" element={<AdminRoute><AdminIscritti /></AdminRoute>} />
              <Route path="/admin/iscritti/:id" element={<AdminRoute><AdminIscrittoDettaglio /></AdminRoute>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
